// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"caa5ec62","977":"8fabcd83"}[chunkId] + ".chunk.js");